import React from 'react';
import { IonItem, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import { RadioGroupChangeEventDetail } from '@ionic/core';
import { AvailableValues } from '../../api/types/generated/filterData_get.response';

interface IRadioListProps {
  onChange: (value: string) => void;
  items: AvailableValues;
  slot?: string;
  value?: string;
}

//TODO: Should be united with RadioButton component to use input components from one source
export default function RadioList({ items, value, onChange }: IRadioListProps) {
  const handleChange = ({
    detail,
  }: CustomEvent<RadioGroupChangeEventDetail>) => {
    onChange(detail.value);
  };

  return (
    <IonList>
      <IonRadioGroup
        value={value}
        onIonChange={handleChange}
        allowEmptySelection
      >
        {items.map(({ key, label }) => (
          <IonItem key={key} lines="none">
            <IonRadio slot="start" labelPlacement="end" value={key}>
              {label}
            </IonRadio>
          </IonItem>
        ))}
      </IonRadioGroup>
    </IonList>
  );
}
